import styled from "styled-components";

export const Filter = styled("div")`
  width: 100%;
`;
